import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

export default {
  getAll(params: any): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'get',
      url: '/permissions',
      headers: {
        'Content-Type': 'application/json',
      },
      params,
    });
  },
};
